var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _path, _path2, _path3, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _rect280, _rect281, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _circle, _circle2, _path128, _path129, _path130, _path131, _circle3, _image, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgI4CIntro = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 874,
    height: 554,
    viewBox: "0 0 874 554",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "i4c-image-a",
    width: "134.2%",
    height: "280%",
    x: "-17.1%",
    y: "-90%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 18
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 280)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 55.862,
    y: 56.291,
    fill: "#FFF",
    opacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 55.254,
    y: 55.668,
    fill: "#FEFEFF",
    opacity: 0.51
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 54.633,
    y: 55.057,
    fill: "#FEFEFE",
    opacity: 0.51
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 54.025,
    y: 54.434,
    fill: "#FDFDFE",
    opacity: 0.52
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 53.404,
    y: 53.823,
    fill: "#FDFDFD",
    opacity: 0.52
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 52.796,
    y: 53.2,
    fill: "#FCFCFD",
    opacity: 0.53
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 52.175,
    y: 52.59,
    fill: "#FCFCFC",
    opacity: 0.53
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 51.567,
    y: 51.967,
    fill: "#FBFBFC",
    opacity: 0.54
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 50.946,
    y: 51.356,
    fill: "#FBFBFB",
    opacity: 0.54
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 50.338,
    y: 50.745,
    fill: "#FAFAFB",
    opacity: 0.55
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 49.717,
    y: 50.122,
    fill: "#F9FAFB",
    opacity: 0.55
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 49.109,
    y: 49.512,
    fill: "#F9F9FA",
    opacity: 0.56
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 48.501,
    y: 48.889,
    fill: "#F8F9FA",
    opacity: 0.57
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 47.88,
    y: 48.278,
    fill: "#F8F8F9",
    opacity: 0.57
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 47.272,
    y: 47.655,
    fill: "#F7F8F9",
    opacity: 0.58
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 46.651,
    y: 47.044,
    fill: "#F7F7F8",
    opacity: 0.58
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 46.043,
    y: 46.421,
    fill: "#F6F7F8",
    opacity: 0.59
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 45.422,
    y: 45.81,
    fill: "#F5F6F8",
    opacity: 0.59
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 44.814,
    y: 45.187,
    fill: "#F5F6F7",
    opacity: 0.6
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 44.193,
    y: 44.577,
    fill: "#F4F5F7",
    opacity: 0.6
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 43.585,
    y: 43.966,
    fill: "#F4F5F6",
    opacity: 0.61
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 42.977,
    y: 43.343,
    fill: "#F3F4F6",
    opacity: 0.62
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 42.356,
    y: 42.732,
    fill: "#F3F4F5",
    opacity: 0.62
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 41.748,
    y: 42.109,
    fill: "#F2F3F5",
    opacity: 0.63
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 41.127,
    y: 41.499,
    fill: "#F2F3F4",
    opacity: 0.63
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 40.519,
    y: 40.875,
    fill: "#F1F2F4",
    opacity: 0.64
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 39.898,
    y: 40.265,
    fill: "#F0F2F4",
    opacity: 0.64
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 39.29,
    y: 39.642,
    fill: "#F0F1F3",
    opacity: 0.65
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 38.669,
    y: 39.031,
    fill: "#EFF1F3",
    opacity: 0.65
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 38.061,
    y: 38.42,
    fill: "#EFF0F2",
    opacity: 0.66
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 37.44,
    y: 37.797,
    fill: "#EEF0F2",
    opacity: 0.66
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 36.832,
    y: 37.187,
    fill: "#EEEFF1",
    opacity: 0.67
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 36.223,
    y: 36.564,
    fill: "#EDEFF1",
    opacity: 0.68
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 35.603,
    y: 35.953,
    fill: "#EDEEF0",
    opacity: 0.68
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 34.994,
    y: 35.33,
    fill: "#ECEEF0",
    opacity: 0.69
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 34.374,
    y: 34.719,
    fill: "#EBEDF0",
    opacity: 0.69
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 33.766,
    y: 34.096,
    fill: "#EBEDEF",
    opacity: 0.7
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 33.145,
    y: 33.485,
    fill: "#EAECEF",
    opacity: 0.7
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 32.537,
    y: 32.862,
    fill: "#EAECEE",
    opacity: 0.71
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 31.916,
    y: 32.252,
    fill: "#E9EBEE",
    opacity: 0.71
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 31.308,
    y: 31.641,
    fill: "#E9EBED",
    opacity: 0.72
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 30.699,
    y: 31.018,
    fill: "#E8EAED",
    opacity: 0.73
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 30.079,
    y: 30.407,
    fill: "#E7EAED",
    opacity: 0.73
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 29.47,
    y: 29.784,
    fill: "#E7E9EC",
    opacity: 0.74
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 28.85,
    y: 29.174,
    fill: "#E6E9EC",
    opacity: 0.74
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 28.241,
    y: 28.55,
    fill: "#E6E8EB",
    opacity: 0.75
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 27.621,
    y: 27.94,
    fill: "#E5E8EB",
    opacity: 0.75
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 27.012,
    y: 27.317,
    fill: "#E5E7EA",
    opacity: 0.76
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 26.392,
    y: 26.706,
    fill: "#E4E7EA",
    opacity: 0.76
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 25.783,
    y: 26.083,
    fill: "#E4E6E9",
    opacity: 0.77
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 25.163,
    y: 25.472,
    fill: "#E3E6E9",
    opacity: 0.77
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 24.554,
    y: 24.862,
    fill: "#E2E5E9",
    opacity: 0.78
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 23.946,
    y: 24.239,
    fill: "#E2E5E8",
    opacity: 0.79
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 23.326,
    y: 23.628,
    fill: "#E1E4E8",
    opacity: 0.79
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 22.717,
    y: 23.005,
    fill: "#E1E4E7",
    opacity: 0.8
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 22.097,
    y: 22.394,
    fill: "#E0E3E7",
    opacity: 0.8
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 21.488,
    y: 21.771,
    fill: "#E0E3E6",
    opacity: 0.81
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 20.868,
    y: 21.161,
    fill: "#DFE2E6",
    opacity: 0.81
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 20.259,
    y: 20.537,
    fill: "#DEE2E6",
    opacity: 0.82
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 19.639,
    y: 19.927,
    fill: "#DEE1E5",
    opacity: 0.82
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 19.03,
    y: 19.316,
    fill: "#DDE1E5",
    opacity: 0.83
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 18.422,
    y: 18.693,
    fill: "#DDE0E4",
    opacity: 0.84
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 17.801,
    y: 18.082,
    fill: "#DCE0E4",
    opacity: 0.84
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 17.193,
    y: 17.459,
    fill: "#DCDFE3",
    opacity: 0.85
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 16.572,
    y: 16.849,
    fill: "#DBDFE3",
    opacity: 0.85
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 15.964,
    y: 16.226,
    fill: "#DBDEE2",
    opacity: 0.86
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 15.343,
    y: 15.615,
    fill: "#DADEE2",
    opacity: 0.86
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 14.735,
    y: 14.992,
    fill: "#D9DDE2",
    opacity: 0.87
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 14.114,
    y: 14.381,
    fill: "#D9DDE1",
    opacity: 0.87
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 13.506,
    y: 13.758,
    fill: "#D8DCE1",
    opacity: 0.88
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 12.886,
    y: 13.147,
    fill: "#D8DCE0",
    opacity: 0.88
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 12.277,
    y: 12.537,
    fill: "#D7DBE0",
    opacity: 0.89
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 11.669,
    y: 11.914,
    fill: "#D7DBDF",
    opacity: 0.9
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 11.048,
    y: 11.303,
    fill: "#D6DADF",
    opacity: 0.9
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 10.44,
    y: 10.68,
    fill: "#D6DADE",
    opacity: 0.91
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 9.819,
    y: 10.069,
    fill: "#D5D9DE",
    opacity: 0.91
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 9.211,
    y: 9.446,
    fill: "#D4D9DE",
    opacity: 0.92
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 8.59,
    y: 8.836,
    fill: "#D4D8DD",
    opacity: 0.92
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 7.982,
    y: 8.212,
    fill: "#D3D8DD",
    opacity: 0.93
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 7.361,
    y: 7.602,
    fill: "#D3D7DC",
    opacity: 0.93
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 6.753,
    y: 6.991,
    fill: "#D2D7DC",
    opacity: 0.94
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 6.145,
    y: 6.368,
    fill: "#D2D6DB",
    opacity: 0.95
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 5.524,
    y: 5.757,
    fill: "#D1D6DB",
    opacity: 0.95
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 4.916,
    y: 5.134,
    fill: "#D0D5DB",
    opacity: 0.96
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 4.295,
    y: 4.524,
    fill: "#D0D5DA",
    opacity: 0.96
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 3.687,
    y: 3.901,
    fill: "#CFD4DA",
    opacity: 0.97
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 3.066,
    y: 3.29,
    fill: "#CFD4D9",
    opacity: 0.97
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 2.458,
    y: 2.667,
    fill: "#CED3D9",
    opacity: 0.98
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 1.837,
    y: 2.056,
    fill: "#CED3D8",
    opacity: 0.98
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 1.229,
    y: 1.433,
    fill: "#CDD2D8",
    opacity: 0.99
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    x: 0.608,
    y: 0.822,
    fill: "#CDD2D7",
    opacity: 0.99
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.674,
    y: 0.212,
    fill: "#CCD1D7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C1D",
    fillRule: "nonzero",
    d: "M669.769677,177.649676 C671.065074,175.863891 673.563362,175.465993 675.349759,176.760946 C677.136156,178.055899 677.53419,180.553331 676.238793,182.339116 C645.172373,225.166103 629.725791,259.893299 629.725791,286.27621 C629.725791,303.522266 631.866887,317.520258 636.158657,334.032902 C636.594064,335.708135 639.908185,347.849713 640.685842,351.062362 C642.138498,357.063555 642.848312,361.669382 642.848312,366.034398 C642.848312,367.255428 642.854205,368.293317 642.869135,370.157772 C642.941921,379.246814 642.79301,382.340198 641.733259,386.707391 C640.119026,393.359582 636.438763,399.720432 628.828082,409.060145 C620.872403,418.823235 608.389775,430.175738 596.026909,438.640631 C581.267312,448.746573 567.89265,454.116589 557.688295,452.805031 C546.754493,451.399717 534.96702,444.375112 527.478019,434.723844 C518.877616,423.640283 516.791666,410.495642 523.146416,398.177236 C525.339485,393.926067 527.832216,390.099501 530.830134,386.20248 C532.848351,383.57898 539.551497,375.703413 540.715298,374.196962 C547.100168,365.932246 548.36472,359.406703 544.272402,347.139981 C541.696446,339.418555 538.330172,333.871114 533.594367,328.625999 C532.521446,327.437692 531.414553,326.296355 529.934002,324.831129 C529.66155,324.561497 529.383928,324.288112 529.012717,323.923563 C528.782489,323.697527 528.782489,323.697527 528.552409,323.4717 C528.322426,323.24591 528.322426,323.24591 528.092684,323.020065 C527.344034,322.283722 526.797064,321.739667 526.265701,321.199738 C519.061629,313.879541 516,307.697287 516,297.267489 L516,275.409553 C516,273.203667 517.456989,273.725288 519.663631,273.725288 C521.870273,273.725288 523.146416,272.356166 523.146416,274.562051 L523.990957,297.267489 C523.990957,305.366679 526.115467,309.656636 531.962116,315.597531 C532.457228,316.100624 532.976722,316.61735 533.697094,317.325879 C533.922917,317.547872 533.922917,317.547872 534.151258,317.772049 C534.380822,317.99737 534.380822,317.99737 534.612758,318.225083 C534.990662,318.596205 535.274916,318.87612 535.555965,319.154261 C537.133828,320.715792 538.336766,321.956162 539.526356,323.273686 C544.972162,329.305159 548.912319,335.798327 551.852917,344.612767 C556.810791,359.473994 555.011026,368.761425 547.039788,379.079572 C545.720003,380.787931 539.023924,388.655195 537.164601,391.072148 C534.442382,394.610786 532.206938,398.042393 530.248594,401.838557 C525.421807,411.195073 526.986945,421.057812 533.792068,429.827749 C540.016295,437.849071 549.923285,443.753024 558.707331,444.882031 C573.899734,446.8347 605.208609,425.397415 622.632543,404.015026 C629.557429,395.51691 632.684223,390.112658 633.967521,384.824234 C634.815352,381.330354 634.945708,378.622433 634.878435,370.221719 C634.863343,368.337204 634.857355,367.28251 634.857355,366.034398 C634.857355,362.414298 634.235692,358.380463 632.919038,352.941116 C632.173938,349.862969 628.885706,337.816237 628.424489,336.041698 C623.974882,318.92178 621.734834,304.276858 621.734834,286.27621 C621.734834,257.843414 637.8042,221.716068 669.769677,177.649676 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1C1D",
    strokeWidth: 8,
    d: "M660,167 C645.076823,181.656635 633.412527,202.898031 625.00711,230.724188 C612.398984,272.463422 622.15559,289.478056 598.291641,292.85922 C574.427692,296.240384 559.80614,237.841347 565.071768,211.925483 C570.337397,186.009619 583.452393,172.006278 575.293176,170.19465"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1C1D",
    strokeWidth: 8,
    d: "M673,171.969373 C634.743345,255.879404 615.615018,307.17359 615.615018,325.85193 C615.615018,353.86944 633.679611,412.778646 633.679611,432.319151 C633.679611,451.859657 416.632422,462.945484 389.980487,444.789407 C363.328553,426.633329 354.219735,420.800737 308.16551,424.283268 C262.111284,427.7658 202.38533,446.979465 202.38533,417.085124 C202.38533,387.190783 203.388604,365.505545 217.525126,331.22213 C231.661647,296.938716 217.525126,253.782534 217.525126,248.625012 C217.525126,243.467491 179.361052,204.60848 202.38533,173.272077 C225.409609,141.935675 237.754976,59.0594775 231.582292,55"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 592,
    height: 9,
    y: 281,
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 175)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 55.862,
    y: 55.672,
    fill: "#FFF",
    opacity: 0.5
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 55.254,
    y: 55.069,
    fill: "#FEFEFF",
    opacity: 0.51
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 54.633,
    y: 54.453,
    fill: "#FEFEFE",
    opacity: 0.51
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 54.025,
    y: 53.85,
    fill: "#FDFDFE",
    opacity: 0.52
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 53.404,
    y: 53.234,
    fill: "#FDFDFD",
    opacity: 0.52
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 52.796,
    y: 52.631,
    fill: "#FCFCFD",
    opacity: 0.53
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 52.175,
    y: 52.015,
    fill: "#FCFCFC",
    opacity: 0.53
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 51.567,
    y: 51.412,
    fill: "#FBFBFC",
    opacity: 0.54
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 50.946,
    y: 50.808,
    fill: "#FBFBFB",
    opacity: 0.54
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 50.338,
    y: 50.192,
    fill: "#FAFAFB",
    opacity: 0.55
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 49.717,
    y: 49.589,
    fill: "#F9FAFB",
    opacity: 0.55
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 49.109,
    y: 48.973,
    fill: "#F9F9FA",
    opacity: 0.56
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 48.501,
    y: 48.37,
    fill: "#F8F9FA",
    opacity: 0.57
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 47.88,
    y: 47.754,
    fill: "#F8F8F9",
    opacity: 0.57
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 47.272,
    y: 47.151,
    fill: "#F7F8F9",
    opacity: 0.58
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 46.651,
    y: 46.535,
    fill: "#F7F7F8",
    opacity: 0.58
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 46.043,
    y: 45.932,
    fill: "#F6F7F8",
    opacity: 0.59
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 45.422,
    y: 45.316,
    fill: "#F5F6F8",
    opacity: 0.59
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 44.814,
    y: 44.713,
    fill: "#F5F6F7",
    opacity: 0.6
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 44.193,
    y: 44.109,
    fill: "#F4F5F7",
    opacity: 0.6
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 43.585,
    y: 43.494,
    fill: "#F4F5F6",
    opacity: 0.61
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 42.977,
    y: 42.89,
    fill: "#F3F4F6",
    opacity: 0.62
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 42.356,
    y: 42.275,
    fill: "#F3F4F5",
    opacity: 0.62
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 41.748,
    y: 41.671,
    fill: "#F2F3F5",
    opacity: 0.63
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 41.127,
    y: 41.056,
    fill: "#F2F3F4",
    opacity: 0.63
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 40.519,
    y: 40.452,
    fill: "#F1F2F4",
    opacity: 0.64
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 39.898,
    y: 39.837,
    fill: "#F0F2F4",
    opacity: 0.64
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 39.29,
    y: 39.233,
    fill: "#F0F1F3",
    opacity: 0.65
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 38.669,
    y: 38.63,
    fill: "#EFF1F3",
    opacity: 0.65
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 38.061,
    y: 38.014,
    fill: "#EFF0F2",
    opacity: 0.66
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 37.44,
    y: 37.411,
    fill: "#EEF0F2",
    opacity: 0.66
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 36.832,
    y: 36.795,
    fill: "#EEEFF1",
    opacity: 0.67
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 36.223,
    y: 36.192,
    fill: "#EDEFF1",
    opacity: 0.68
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 35.603,
    y: 35.576,
    fill: "#EDEEF0",
    opacity: 0.68
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 34.994,
    y: 34.973,
    fill: "#ECEEF0",
    opacity: 0.69
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 34.374,
    y: 34.357,
    fill: "#EBEDF0",
    opacity: 0.69
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 33.766,
    y: 33.754,
    fill: "#EBEDEF",
    opacity: 0.7
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 33.145,
    y: 33.138,
    fill: "#EAECEF",
    opacity: 0.7
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 32.537,
    y: 32.535,
    fill: "#EAECEE",
    opacity: 0.71
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 31.916,
    y: 31.931,
    fill: "#E9EBEE",
    opacity: 0.71
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 31.308,
    y: 31.316,
    fill: "#E9EBED",
    opacity: 0.72
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 30.699,
    y: 30.712,
    fill: "#E8EAED",
    opacity: 0.73
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 30.079,
    y: 30.097,
    fill: "#E7EAED",
    opacity: 0.73
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 29.47,
    y: 29.493,
    fill: "#E7E9EC",
    opacity: 0.74
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 28.85,
    y: 28.877,
    fill: "#E6E9EC",
    opacity: 0.74
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 28.241,
    y: 28.274,
    fill: "#E6E8EB",
    opacity: 0.75
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 27.621,
    y: 27.658,
    fill: "#E5E8EB",
    opacity: 0.75
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 27.012,
    y: 27.055,
    fill: "#E5E7EA",
    opacity: 0.76
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 26.392,
    y: 26.452,
    fill: "#E4E7EA",
    opacity: 0.76
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 25.783,
    y: 25.836,
    fill: "#E4E6E9",
    opacity: 0.77
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 25.163,
    y: 25.233,
    fill: "#E3E6E9",
    opacity: 0.77
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 24.554,
    y: 24.617,
    fill: "#E2E5E9",
    opacity: 0.78
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 23.946,
    y: 24.014,
    fill: "#E2E5E8",
    opacity: 0.79
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 23.326,
    y: 23.398,
    fill: "#E1E4E8",
    opacity: 0.79
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 22.717,
    y: 22.795,
    fill: "#E1E4E7",
    opacity: 0.8
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 22.097,
    y: 22.179,
    fill: "#E0E3E7",
    opacity: 0.8
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 21.488,
    y: 21.575,
    fill: "#E0E3E6",
    opacity: 0.81
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 20.868,
    y: 20.96,
    fill: "#DFE2E6",
    opacity: 0.81
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 20.259,
    y: 20.356,
    fill: "#DEE2E6",
    opacity: 0.82
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 19.639,
    y: 19.753,
    fill: "#DEE1E5",
    opacity: 0.82
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 19.03,
    y: 19.137,
    fill: "#DDE1E5",
    opacity: 0.83
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 18.422,
    y: 18.534,
    fill: "#DDE0E4",
    opacity: 0.84
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 17.801,
    y: 17.918,
    fill: "#DCE0E4",
    opacity: 0.84
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 17.193,
    y: 17.315,
    fill: "#DCDFE3",
    opacity: 0.85
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 16.572,
    y: 16.699,
    fill: "#DBDFE3",
    opacity: 0.85
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 15.964,
    y: 16.096,
    fill: "#DBDEE2",
    opacity: 0.86
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 15.343,
    y: 15.48,
    fill: "#DADEE2",
    opacity: 0.86
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 14.735,
    y: 14.877,
    fill: "#D9DDE2",
    opacity: 0.87
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 14.114,
    y: 14.273,
    fill: "#D9DDE1",
    opacity: 0.87
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 13.506,
    y: 13.658,
    fill: "#D8DCE1",
    opacity: 0.88
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 12.886,
    y: 13.054,
    fill: "#D8DCE0",
    opacity: 0.88
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 12.277,
    y: 12.439,
    fill: "#D7DBE0",
    opacity: 0.89
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 11.669,
    y: 11.835,
    fill: "#D7DBDF",
    opacity: 0.9
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 11.048,
    y: 11.22,
    fill: "#D6DADF",
    opacity: 0.9
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 10.44,
    y: 10.616,
    fill: "#D6DADE",
    opacity: 0.91
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 9.819,
    y: 10.001,
    fill: "#D5D9DE",
    opacity: 0.91
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 9.211,
    y: 9.397,
    fill: "#D4D9DE",
    opacity: 0.92
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 8.59,
    y: 8.782,
    fill: "#D4D8DD",
    opacity: 0.92
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 7.982,
    y: 8.178,
    fill: "#D3D8DD",
    opacity: 0.93
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 7.361,
    y: 7.575,
    fill: "#D3D7DC",
    opacity: 0.93
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 6.753,
    y: 6.959,
    fill: "#D2D7DC",
    opacity: 0.94
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 6.145,
    y: 6.356,
    fill: "#D2D6DB",
    opacity: 0.95
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 5.524,
    y: 5.74,
    fill: "#D1D6DB",
    opacity: 0.95
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 4.916,
    y: 5.137,
    fill: "#D0D5DB",
    opacity: 0.96
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 4.295,
    y: 4.521,
    fill: "#D0D5DA",
    opacity: 0.96
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 3.687,
    y: 3.918,
    fill: "#CFD4DA",
    opacity: 0.97
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 3.066,
    y: 3.302,
    fill: "#CFD4D9",
    opacity: 0.97
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 2.458,
    y: 2.699,
    fill: "#CED3D9",
    opacity: 0.98
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 1.837,
    y: 2.095,
    fill: "#CED3D8",
    opacity: 0.98
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 1.229,
    y: 1.48,
    fill: "#CDD2D8",
    opacity: 0.99
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    x: 0.608,
    y: 0.876,
    fill: "#CDD2D7",
    opacity: 0.99
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.558,
    y: 0.261,
    fill: "#CCD1D7"
  }))), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 592,
    height: 9,
    y: 175,
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 61)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 55.862,
    y: 56.241,
    fill: "#FFF",
    opacity: 0.5
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 55.254,
    y: 55.63,
    fill: "#FEFEFF",
    opacity: 0.51
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 54.633,
    y: 55.007,
    fill: "#FEFEFE",
    opacity: 0.51
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 54.025,
    y: 54.397,
    fill: "#FDFDFE",
    opacity: 0.52
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 53.404,
    y: 53.774,
    fill: "#FDFDFD",
    opacity: 0.52
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 52.796,
    y: 53.163,
    fill: "#FCFCFD",
    opacity: 0.53
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 52.175,
    y: 52.54,
    fill: "#FCFCFC",
    opacity: 0.53
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 51.567,
    y: 51.929,
    fill: "#FBFBFC",
    opacity: 0.54
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 50.946,
    y: 51.306,
    fill: "#FBFBFB",
    opacity: 0.54
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 50.338,
    y: 50.696,
    fill: "#FAFAFB",
    opacity: 0.55
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 49.717,
    y: 50.072,
    fill: "#F9FAFB",
    opacity: 0.55
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 49.109,
    y: 49.462,
    fill: "#F9F9FA",
    opacity: 0.56
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 48.501,
    y: 48.851,
    fill: "#F8F9FA",
    opacity: 0.57
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 47.88,
    y: 48.228,
    fill: "#F8F8F9",
    opacity: 0.57
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 47.272,
    y: 47.617,
    fill: "#F7F8F9",
    opacity: 0.58
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 46.651,
    y: 46.994,
    fill: "#F7F7F8",
    opacity: 0.58
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 46.043,
    y: 46.384,
    fill: "#F6F7F8",
    opacity: 0.59
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 45.422,
    y: 45.761,
    fill: "#F5F6F8",
    opacity: 0.59
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 44.814,
    y: 45.15,
    fill: "#F5F6F7",
    opacity: 0.6
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 44.193,
    y: 44.527,
    fill: "#F4F5F7",
    opacity: 0.6
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 43.585,
    y: 43.916,
    fill: "#F4F5F6",
    opacity: 0.61
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 42.977,
    y: 43.306,
    fill: "#F3F4F6",
    opacity: 0.62
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 42.356,
    y: 42.682,
    fill: "#F3F4F5",
    opacity: 0.62
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 41.748,
    y: 42.072,
    fill: "#F2F3F5",
    opacity: 0.63
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 41.127,
    y: 41.449,
    fill: "#F2F3F4",
    opacity: 0.63
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 40.519,
    y: 40.838,
    fill: "#F1F2F4",
    opacity: 0.64
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 39.898,
    y: 40.215,
    fill: "#F0F2F4",
    opacity: 0.64
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 39.29,
    y: 39.604,
    fill: "#F0F1F3",
    opacity: 0.65
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 38.669,
    y: 38.981,
    fill: "#EFF1F3",
    opacity: 0.65
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 38.061,
    y: 38.371,
    fill: "#EFF0F2",
    opacity: 0.66
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 37.44,
    y: 37.747,
    fill: "#EEF0F2",
    opacity: 0.66
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 36.832,
    y: 37.137,
    fill: "#EEEFF1",
    opacity: 0.67
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 36.223,
    y: 36.526,
    fill: "#EDEFF1",
    opacity: 0.68
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 35.603,
    y: 35.903,
    fill: "#EDEEF0",
    opacity: 0.68
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 34.994,
    y: 35.292,
    fill: "#ECEEF0",
    opacity: 0.69
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 34.374,
    y: 34.669,
    fill: "#EBEDF0",
    opacity: 0.69
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 33.766,
    y: 34.059,
    fill: "#EBEDEF",
    opacity: 0.7
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 33.145,
    y: 33.436,
    fill: "#EAECEF",
    opacity: 0.7
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 32.537,
    y: 32.825,
    fill: "#EAECEE",
    opacity: 0.71
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 31.916,
    y: 32.202,
    fill: "#E9EBEE",
    opacity: 0.71
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 31.308,
    y: 31.591,
    fill: "#E9EBED",
    opacity: 0.72
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 30.699,
    y: 30.968,
    fill: "#E8EAED",
    opacity: 0.73
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 30.079,
    y: 30.357,
    fill: "#E7EAED",
    opacity: 0.73
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 29.47,
    y: 29.747,
    fill: "#E7E9EC",
    opacity: 0.74
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 28.85,
    y: 29.124,
    fill: "#E6E9EC",
    opacity: 0.74
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 28.241,
    y: 28.513,
    fill: "#E6E8EB",
    opacity: 0.75
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 27.621,
    y: 27.89,
    fill: "#E5E8EB",
    opacity: 0.75
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 27.012,
    y: 27.279,
    fill: "#E5E7EA",
    opacity: 0.76
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 26.392,
    y: 26.656,
    fill: "#E4E7EA",
    opacity: 0.76
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 25.783,
    y: 26.046,
    fill: "#E4E6E9",
    opacity: 0.77
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 25.163,
    y: 25.423,
    fill: "#E3E6E9",
    opacity: 0.77
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 24.554,
    y: 24.812,
    fill: "#E2E5E9",
    opacity: 0.78
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 23.946,
    y: 24.201,
    fill: "#E2E5E8",
    opacity: 0.79
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 23.326,
    y: 23.578,
    fill: "#E1E4E8",
    opacity: 0.79
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 22.717,
    y: 22.968,
    fill: "#E1E4E7",
    opacity: 0.8
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 22.097,
    y: 22.344,
    fill: "#E0E3E7",
    opacity: 0.8
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 21.488,
    y: 21.734,
    fill: "#E0E3E6",
    opacity: 0.81
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 20.868,
    y: 21.111,
    fill: "#DFE2E6",
    opacity: 0.81
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 20.259,
    y: 20.5,
    fill: "#DEE2E6",
    opacity: 0.82
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 19.639,
    y: 19.877,
    fill: "#DEE1E5",
    opacity: 0.82
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 19.03,
    y: 19.266,
    fill: "#DDE1E5",
    opacity: 0.83
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 18.422,
    y: 18.643,
    fill: "#DDE0E4",
    opacity: 0.84
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 17.801,
    y: 18.033,
    fill: "#DCE0E4",
    opacity: 0.84
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 17.193,
    y: 17.422,
    fill: "#DCDFE3",
    opacity: 0.85
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 16.572,
    y: 16.799,
    fill: "#DBDFE3",
    opacity: 0.85
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 15.964,
    y: 16.188,
    fill: "#DBDEE2",
    opacity: 0.86
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 15.343,
    y: 15.565,
    fill: "#DADEE2",
    opacity: 0.86
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 14.735,
    y: 14.954,
    fill: "#D9DDE2",
    opacity: 0.87
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 14.114,
    y: 14.331,
    fill: "#D9DDE1",
    opacity: 0.87
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 13.506,
    y: 13.721,
    fill: "#D8DCE1",
    opacity: 0.88
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 12.886,
    y: 13.098,
    fill: "#D8DCE0",
    opacity: 0.88
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 12.277,
    y: 12.487,
    fill: "#D7DBE0",
    opacity: 0.89
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 11.669,
    y: 11.876,
    fill: "#D7DBDF",
    opacity: 0.9
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 11.048,
    y: 11.253,
    fill: "#D6DADF",
    opacity: 0.9
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 10.44,
    y: 10.643,
    fill: "#D6DADE",
    opacity: 0.91
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 9.819,
    y: 10.019,
    fill: "#D5D9DE",
    opacity: 0.91
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 9.211,
    y: 9.409,
    fill: "#D4D9DE",
    opacity: 0.92
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 8.59,
    y: 8.786,
    fill: "#D4D8DD",
    opacity: 0.92
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 7.982,
    y: 8.175,
    fill: "#D3D8DD",
    opacity: 0.93
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 7.361,
    y: 7.552,
    fill: "#D3D7DC",
    opacity: 0.93
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 6.753,
    y: 6.941,
    fill: "#D2D7DC",
    opacity: 0.94
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 6.145,
    y: 6.318,
    fill: "#D2D6DB",
    opacity: 0.95
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 5.524,
    y: 5.708,
    fill: "#D1D6DB",
    opacity: 0.95
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 4.916,
    y: 5.097,
    fill: "#D0D5DB",
    opacity: 0.96
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 4.295,
    y: 4.474,
    fill: "#D0D5DA",
    opacity: 0.96
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 3.687,
    y: 3.863,
    fill: "#CFD4DA",
    opacity: 0.97
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 3.066,
    y: 3.24,
    fill: "#CFD4D9",
    opacity: 0.97
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 2.458,
    y: 2.629,
    fill: "#CED3D9",
    opacity: 0.98
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 1.837,
    y: 2.006,
    fill: "#CED3D8",
    opacity: 0.98
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 1.229,
    y: 1.396,
    fill: "#CDD2D8",
    opacity: 0.99
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    x: 0.608,
    y: 0.773,
    fill: "#CDD2D7",
    opacity: 0.99
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    width: 591.554,
    height: 8.661,
    y: 0.162,
    fill: "#CCD1D7"
  }))), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    width: 592,
    height: 9,
    y: 61,
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M693.756471,509 C792.105007,509 834,477.594589 834,463.748697 C834,449.902804 792.105007,452.001829 693.756471,452.001829 C595.407936,452.001829 518,440.081646 518,463.748697 C518,487.415748 595.407936,509 693.756471,509 Z",
    filter: "url(#i4c-image-a)",
    opacity: 0.11
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(324)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(474)"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 114)"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164 114)"
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(324 114)"
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(474 114)"
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 219)"
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164 219)"
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(324 219)"
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(474 219)"
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M53.0325,0.109090909 C25.8525,0.519454545 3.645,24.8861818 0,50.5505455 C14.625,58.2254545 33.24375,59.4787273 53.73,59.1792727 C74.21625,58.8798182 93.105,57.0387273 107.46,48.9312727 C103.03875,23.4 80.2125,-0.301272727 53.0325,0.109090909 Z M48.7125,53.6338182 C18.7875,53.5229091 5.36625,46.0254545 3.78,43.1529091 C2.19375,40.2803636 6.8175,17.5329091 29.34,6.85236364 C44.26875,-0.234727273 86.4675,-4.77090909 95.4,33.1267273 C97.56,42.3321818 78.64875,53.7447273 48.7125,53.6338182 L48.7125,53.6338182 Z",
    opacity: 0.55,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.10830363 36.9835864C6.10830363 36.9835864 16.3078602 5.6637466 52.1083036 5 52.1083036 5 20.6710038 13.403707 13.4293187 41 13.4293187 41.0110658 7.93289097 40.5160683 6.10830363 36.9835864zM5.45378102 41C5.45378102 41 7.81684635 43.3076572 13.1083036 43.8153418 12.418025 45.8129727 11.9736657 47.8903963 11.7854393 49.9998632 11.7854393 49.9998632 7.12714786 50.069093 4.10830363 47.0922151 4.14826366 44.9894937 4.60599495 42.9169227 5.45378102 41L5.45378102 41z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C0C1",
    d: "M0.108303635,50.605753 L0.108303635,62 L108.108304,62 L107.579554,49 C107.579554,49 59.1933036,70.4027073 0.108303635,50.605753 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8,
    x: 3.108,
    y: 53,
    fill: "#FFF",
    opacity: 0.4,
    rx: 2.26,
    style: {
      mixBlendMode: "screen"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M10.1083036,35.6388235 C10.1083036,45.5523529 28.925205,48 50.6716839,48 C72.4181628,48 90.1083036,41.0817647 90.1083036,31.1682353 C90.1083036,21.2547059 72.4181628,10 50.6716839,10 C28.925205,10 10.1083036,25.7252941 10.1083036,35.6388235 Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M17.1083036,35.8992857 C17.1083036,43.9814286 33.131524,45 51.1761002,45 C69.2206765,45 84.1083036,39.5528571 84.1083036,31.4707143 C84.1083036,23.3885714 69.2206765,14 51.1761002,14 C33.131524,14 17.1083036,27.8171429 17.1083036,35.8992857 Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6064702,24.54 L17.6064702,24.54 C17.6113594,24.5135574 17.6113594,24.4864426 17.6064702,24.46 C17.6064702,24.46 17.6064702,24.46 17.6064702,24.52 L17.6064702,24.52 L17.6064702,24.54 Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M17.6383036 24.535C17.624028 24.5073124 17.6034822 24.4833422 17.5783036 24.465L17.5783036 24.465 17.6383036 24.535zM23.6483036 30.465C23.6155199 30.4802464 23.5877669 30.5045302 23.5683036 30.535L23.5683036 30.535 23.6483036 30.465z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M23.6683036,30.505838 L23.6683036,30.505838 C23.6298184,30.49027 23.5867889,30.49027 23.5483036,30.505838 L23.5483036,30.505838 L23.6683036,30.505838 Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M78.303075 36.3604177C78.557914 36.7315876 79.0000798 36.9636933 79.4825987 36.9795843 81.727292 37.1555527 83.8930079 36.1837471 85.0971315 34.4602167 85.9277869 33.608296 86.5901358 32.6332718 87.0551409 31.5778893 87.1933496 31.1441999 87.0574596 30.6768479 86.7012838 30.3609066 86.3447108 30.0504086 85.8358815 29.9292201 85.3566268 30.040648 82.2540507 30.6278595 79.6346668 32.4967417 78.2794845 35.0900586 78.0431178 35.4884987 78.0520479 35.9693913 78.303075 36.3604177L78.303075 36.3604177zM13.1415545 31.0815462C13.2386694 31.6059377 13.4805051 32.0987606 13.8440086 32.5130368 14.2118114 32.9751582 14.6093874 33.4166847 15.0346088 33.8352532 15.4407732 34.2250789 15.8742832 34.590105 16.332363 34.9279941 17.106889 35.6550701 17.9743895 36.2934959 18.9159654 36.8293632 19.5810539 37.1788674 20.4286202 36.9746682 20.8209257 36.370412 21.2040963 35.7658318 21.2040963 35.0189861 20.8209257 34.4144059 20.5484403 34.0165921 20.0708468 33.7767465 19.5588895 33.7806162 19.2921302 33.1106533 18.9319544 32.4752209 18.4873493 31.8901745 18.1764894 31.4757779 17.8301174 31.0847943 17.4515271 30.7209418L17.3800911 30.6553773C17.1609681 30.2755141 16.884389 29.9260159 16.558577 29.6172735 15.9363575 28.9968609 14.9448155 28.8237305 14.1178466 29.1911045 13.3810158 29.5609846 12.9870208 30.3238961 13.1415545 31.0815462z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M53.9325,58.0649057 C74.41875,57.7532075 93.09375,57.1409434 107.47125,49.0033962 C103.03875,23.3996226 80.2125,-0.411886792 53.0325,0.0222641509 C25.8525,0.456415094 3.645,24.8801887 0,50.595283 C14.625,58.3877358 33.44625,58.3877358 53.9325,58.0649057 Z",
    opacity: 0.23,
    transform: "translate(.108)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.7776393,16.6635715 C85.4306561,27.9076332 71.828324,40.7563749 52.4253279,45.3557047 C33.0223318,49.9550344 15.0919849,44.5759657 12.438968,33.3319041 C9.78595116,22.0878425 23.3882833,9.23910069 42.7912794,4.63977096 C62.1942755,0.0404412324 80.079656,5.4534116 82.7776393,16.6635715 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.8890957,10.9712392 C67.6446667,16.4767638 58.6655362,24.3111141 45.7615304,28.4713463 C32.8575246,32.6315785 21.0828989,31.5463006 19.327328,26.0407759 C17.571757,20.5352512 26.5620695,12.7009009 39.3989834,8.52936375 C52.2358972,4.35782658 64.1335247,5.4657145 65.8890957,10.9712392 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(636 71)"
  }, _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 8,
    x: 56,
    y: 257.534,
    fill: "#576363",
    rx: 1.42
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 8,
    x: 55,
    y: 257.534,
    fill: "#8D9899",
    rx: 1.42
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#576363",
    d: "M38.9541891,265.332663 C38.2777941,263.626211 38.7738451,261.642058 40.1539209,260.53386 C38.6156867,260.793551 37.3887265,262.05644 37.0761504,263.701757 C36.7635743,265.347073 37.4311241,267.02877 38.7506668,267.920212 C40.0702095,268.811654 41.7642159,268.725351 43,267.703726 C41.3056204,268.016038 39.6333844,267.036018 38.9541891,265.332663 Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M39.9541891,265.332663 C39.2777941,263.626211 39.7738451,261.642058 41.1539209,260.53386 C39.6156867,260.793551 38.3887265,262.05644 38.0761504,263.701757 C37.7635743,265.347073 38.4311241,267.02877 39.7506668,267.920212 C41.0702095,268.811654 42.7642159,268.725351 44,267.703726 C42.3056204,268.016038 40.6333844,267.036018 39.9541891,265.332663 Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#576363",
    d: "M74.0458109,265.332663 C74.7222059,263.626211 74.2261549,261.642058 72.8460791,260.53386 C74.3843133,260.793551 75.6112735,262.05644 75.9238496,263.701757 C76.2364257,265.347073 75.5688759,267.02877 74.2493332,267.920212 C72.9297905,268.811654 71.2357841,268.725351 70,267.703726 C71.6943796,268.016038 73.3666156,267.036018 74.0458109,265.332663 Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M73.0458109,265.332663 C73.7222059,263.626211 73.2261549,261.642058 71.8460791,260.53386 C73.3843133,260.793551 74.6112735,262.05644 74.9238496,263.701757 C75.2364257,265.347073 74.5688759,267.02877 73.2493332,267.920212 C71.9297905,268.811654 70.2357841,268.725351 69,267.703726 C70.6943796,268.016038 72.3666156,267.036018 73.0458109,265.332663 Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#576363",
    d: "M72.5815852,284.524079 C70.7262422,281.346646 68.0018175,279.341837 66,279.493143 C66.1901901,279.21992 66.4402506,278.99067 66.7323722,278.821721 C68.6853649,277.72475 72.112867,279.861952 74.2806888,283.550045 C76.4485106,287.238137 76.5852201,291.181559 74.5834027,292.27853 C74.2813254,292.432325 73.9478635,292.519517 73.6069063,292.53386 C74.7884669,291.001883 74.4271633,287.701513 72.5815852,284.524079 Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M71.5815852,285.524079 C69.7262422,282.346646 67.0018175,280.341837 65,280.493143 C65.1901901,280.21992 65.4402506,279.99067 65.7323722,279.821721 C67.6853649,278.72475 71.112867,280.861952 73.2806888,284.550045 C75.4485106,288.238137 75.5852201,292.181559 73.5834027,293.27853 C73.2813254,293.432325 72.9478635,293.519517 72.6069063,293.53386 C73.8372917,291.973513 73.4759881,288.701513 71.5815852,285.524079 Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#576363",
    d: "M77.5815852,278.524079 C75.7262422,275.346646 73.0018175,273.341837 71,273.493143 C71.1901901,273.21992 71.4402506,272.99067 71.7323722,272.821721 C73.6853649,271.72475 77.112867,273.861952 79.2806888,277.550045 C81.4485106,281.238137 81.5852201,285.181559 79.5834027,286.27853 C79.2813254,286.432325 78.9478635,286.519517 78.6069063,286.53386 C79.7884669,285.001883 79.4271633,281.701513 77.5815852,278.524079 Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M77.5815852,279.524079 C75.7262422,276.346646 73.0018175,274.341837 71,274.493143 C71.1901901,274.21992 71.4402506,273.99067 71.7323722,273.821721 C73.6853649,272.72475 77.112867,274.861952 79.2806888,278.550045 C81.4485106,282.238137 81.5852201,286.181559 79.5834027,287.27853 C79.2813254,287.432325 78.9478635,287.519517 78.6069063,287.53386 C79.8372917,285.973513 79.4759881,282.701513 77.5815852,279.524079 Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#576363",
    d: "M44.4184148,284.524079 C46.2737578,281.346646 48.9981825,279.341837 51,279.493143 C50.8098099,279.21992 50.5597494,278.99067 50.2676278,278.821721 C48.3146351,277.72475 44.887133,279.861952 42.7193112,283.550045 C40.5514894,287.238137 40.4147799,291.181559 42.4165973,292.27853 C42.7186746,292.432325 43.0521365,292.519517 43.3930937,292.53386 C42.2017681,291.001883 42.5630718,287.701513 44.4184148,284.524079 Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M44.4184148,285.524079 C46.2737578,282.346646 48.9981825,280.341837 51,280.493143 C50.8098099,280.21992 50.5597494,279.99067 50.2676278,279.821721 C48.3146351,278.72475 44.887133,280.861952 42.7193112,284.550045 C40.5514894,288.238137 40.4147799,292.181559 42.4165973,293.27853 C42.7186746,293.432325 43.0521365,293.519517 43.3930937,293.53386 C42.231063,291.973513 42.5728367,288.701513 44.4184148,285.524079 Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#576363",
    d: "M38.4184148,278.524079 C40.2737578,275.346646 42.9981825,273.341837 45,273.493143 C44.8098099,273.21992 44.5597494,272.99067 44.2676278,272.821721 C42.3146351,271.72475 38.887133,273.861952 36.7193112,277.550045 C34.5514894,281.238137 34.4147799,285.181559 36.4165973,286.27853 C36.7186746,286.432325 37.0521365,286.519517 37.3930937,286.53386 C36.2017681,285.001883 36.5630718,281.701513 38.4184148,278.524079 Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M38.4184148,279.524079 C40.2737578,276.346646 42.9981825,274.341837 45,274.493143 C44.8098099,274.21992 44.5597494,273.99067 44.2676278,273.821721 C42.3146351,272.72475 38.887133,274.861952 36.7193112,278.550045 C34.5514894,282.238137 34.4147799,286.181559 36.4165973,287.27853 C36.7186746,287.432325 37.0521365,287.519517 37.3930937,287.53386 C36.231063,285.973513 36.5728367,282.701513 38.4184148,279.524079 Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M100.616464,41.5338596 C88.5625594,48.3628978 72.777235,49.909807 55.6315954,50.1739135 C38.4859558,50.4380199 23.0784968,49.3721617 10.8545532,43.0053098 C8.27775626,50.7949616 6.97629717,58.9486525 7,67.1521853 C7,101.3917 28.9354095,153.53386 56.0000141,153.53386 C83.0646188,153.53386 105,101.3917 105,67.1521853 C105.024193,58.4246613 103.541392,49.7582668 100.616464,41.5338596 Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E1E5",
    d: "M61.1115331 50.5044798C75.9452329 50.2694417 89.7643414 49.0159053 101 44.021346 100.746352 43.1889194 100.48331 42.3564929 100.201479 41.5338596 88.2142714 48.6241751 72.5162902 50.2302687 55.4655207 50.5044798L54 50.5044798C56.3423279 50.5436528 58.712839 50.5436528 61.1115331 50.5044798zM12.6864633 66.5652643C12.6712594 59.1830063 13.7374587 51.8376183 15.8517428 44.758642 14.1496493 44.1094596 12.485449 43.3667111 10.8669013 42.5338596 8.28169123 50.2862223 6.97606018 58.4009481 7 66.5652643 7 100.641045 29.0056591 152.53386 56.1569345 152.53386 57.1080008 152.531027 58.0578104 152.465169 59 152.336727 33.1754885 148.900987 12.6864633 99.4488621 12.6864633 66.5652643z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E1E5",
    d: "M104.025856,54.2453756 C87.7089465,53.7462581 40.7346056,32.7644872 59.2527057,152.53386 L59.3370066,152.53386 C60.0207806,152.3926 65.5097066,151.158932 72.797052,146.26193 C91.5305878,131.260152 105,93.3648891 105,66.5067156 C104.997749,62.4001557 104.672016,58.3002244 104.025856,54.2453756 L104.025856,54.2453756 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 79.534,
    r: 19,
    fill: "#D02629"
  })), /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    x: 53,
    y: 56.534,
    opacity: 0.15,
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "multiply"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 79.534,
    r: 19,
    fill: "#D02629"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E323A",
    d: "M78,93.5338596 C70.2680135,93.5338596 64,87.2658461 64,79.5338596 C64,71.8018731 70.2680135,65.5338596 78,65.5338596 C85.7319865,65.5338596 92,71.8018731 92,79.5338596 C91.9897848,87.2616109 85.7277513,93.5236444 78,93.5338596 L78,93.5338596 Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E323A",
    d: "M78,93.5338596 C70.2680135,93.5338596 64,87.2658461 64,79.5338596 C64,71.8018731 70.2680135,65.5338596 78,65.5338596 C85.7319865,65.5338596 92,71.8018731 92,79.5338596 C91.9897848,87.2616109 85.7277513,93.5236444 78,93.5338596 L78,93.5338596 Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDE2E8",
    d: "M77.5,88.5338596 C72.2532949,88.5338596 68,84.2805647 68,79.0338596 C68,73.7871545 72.2532949,69.5338596 77.5,69.5338596 C82.7467051,69.5338596 87,73.7871545 87,79.0338596 C86.9896497,84.2762715 82.7424119,88.5235093 77.5,88.5338596 Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDE2E8",
    d: "M77.5,88.5338596 C72.2532949,88.5338596 68,84.2805647 68,79.0338596 C68,73.7871545 72.2532949,69.5338596 77.5,69.5338596 C82.7467051,69.5338596 87,73.7871545 87,79.0338596 C86.9896497,84.2762715 82.7424119,88.5235093 77.5,88.5338596 Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 79.534,
    r: 5,
    fill: "#D02629"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 116,
    height: 87.054,
    y: 0.804,
    opacity: 0.33,
    transform: "translate(0 120.534)",
    xlinkHref: "data:image/png;base64,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"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M31.518064,218.251851 C35.6875773,230.063085 35.6875773,242.943608 31.518064,254.754842 L30.1173002,258.802382 C29.7833186,259.77502 30.0063344,260.852166 30.6991503,261.612667 C31.3919662,262.373167 32.4445267,262.696214 33.4452893,262.455499 C48.3255092,258.868694 63.8418644,258.83009 78.7397856,262.342806 C79.7709477,262.592548 80.8551716,262.243039 81.5456853,261.438302 C82.236199,260.633564 82.4161429,259.509787 82.0113682,258.530042 L81.8515495,258.145009 C75.9892395,244.308197 75.9892395,228.689105 81.8515495,214.852293 L97.7864128,176.677696 C98.0253747,176.099743 98.0650631,175.458799 97.899226,174.855834 C97.0491511,171.552116 96.6289067,168.152725 96.6488798,164.741679 C96.6495869,163.038284 96.7405916,161.336122 96.9215116,159.642341 C97.0043297,158.846131 96.7441687,158.052319 96.2060133,157.45919 C95.6678579,156.86606 94.9025242,156.529619 94.1011819,156.53386 L21.101646,156.53386 C20.2984839,156.529327 19.5314658,156.867033 18.992981,157.462319 C18.4544962,158.057605 18.1956311,158.853995 18.2813162,159.651732 C18.4638105,161.28883 18.554829,162.934815 18.5539481,164.582031 C18.5780067,168.263861 18.1004374,171.931841 17.1343821,175.485034 C16.955206,176.043907 16.955206,176.644722 17.1343821,177.203595 L31.518064,218.251851 Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFBBBC",
    d: "M51.6190671 260.534125C44.6870321 260.517289 37.7736851 261.302944 31 262.877342 31.6805158 263.46467 32.5808542 263.673505 33.4279869 263.440519 40.1655082 261.6764 47.0645609 260.711826 54 260.564295 53.2094926 260.544181 52.4189853 260.534125 51.6190671 260.534125zM97.7884918 176.69893C98.0251277 176.120367 98.0644298 175.478747 97.9002069 174.875146 97.0584063 171.567945 96.6422524 168.164969 96.6620311 164.750327 96.6627313 163.045136 96.7528502 161.341179 96.9320092 159.645613 97.0140212 158.848563 96.7563925 158.053915 96.2234753 157.46016 95.6905581 156.866405 94.9326739 156.529609 94.1391315 156.53386L89.4843353 156.53386C90.2778776 156.529609 91.0357618 156.866405 91.5686791 157.46016 92.1015963 158.053915 92.3592249 158.848563 92.277213 159.645613 92.098054 161.341179 92.0079351 163.045136 92.0072348 164.750327 91.9874562 168.164969 92.40361 171.567945 93.2454106 174.875146 93.4096336 175.478747 93.3703315 176.120367 93.1336955 176.69893L77.3539363 214.913776C71.5486879 228.765177 71.5486879 244.400736 77.3539363 258.252137L77.5121994 258.637576C77.9924357 259.80694 77.6422294 261.156164 76.6557169 261.937308 77.4191035 262.106525 78.18249 262.275742 78.9272574 262.45436 79.9483825 262.704365 81.022053 262.354488 81.7058455 261.548902 82.389638 260.743315 82.5678304 259.618354 82.1669956 258.637576L82.0087325 258.252137C76.2034841 244.400736 76.2034841 228.765177 82.0087325 214.913776L97.7884918 176.69893z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E1E5",
    d: "M34.5289929 258.811773L35.9121565 254.764233C40.0292812 242.952999 40.0292812 230.072476 35.9121565 218.261242L21.7741822 177.203595C21.5972574 176.644722 21.5972574 176.043907 21.7741822 175.485034 22.7280993 171.931841 23.1996681 168.263861 23.1759118 164.582031 23.1767816 162.934815 23.0869068 161.28883 22.9067054 159.651732 22.822097 158.853995 23.0777095 158.057605 23.6094284 157.462319 24.1411473 156.867033 24.898528 156.529327 25.6915986 156.53386L21.05011 156.53386C20.2570394 156.529327 19.4996587 156.867033 18.9679398 157.462319 18.4362209 158.057605 18.1806083 158.853995 18.2652168 159.651732 18.4454182 161.28883 18.535293 162.934815 18.5344232 164.582031 18.5581795 168.263861 18.0866107 171.931841 17.1326936 175.485034 16.9557688 176.043907 16.9557688 176.644722 17.1326936 177.203595L31.2706679 218.251851C35.3877925 230.063085 35.3877925 242.943608 31.2706679 254.754842L29.8875043 258.802382C29.5577191 259.77502 29.7779328 260.852166 30.4620436 261.612667 31.1461545 262.373167 32.1854899 262.696214 33.1736782 262.455499 33.9163164 262.267678 34.6682376 262.098639 35.4201587 261.9296 34.501769 261.185196 34.145039 259.937143 34.5289929 258.811773zM61.3799749 260.534516C60.5802262 260.534516 59.7901131 260.534516 59 260.534516 65.9191506 260.692333 72.8029683 261.66727 79.5333054 263.442593 80.3933075 263.674379 81.3023161 263.459264 82 262.858855 75.2200529 261.287069 68.3084186 260.507973 61.3799749 260.534516z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M89,269.53386 C89,269.53386 66.2966214,276.677917 67.0167774,304.49816 L69.1772453,404.53386 L78.5485057,404.53386 L89,269.53386 Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFBBBC",
    d: "M84.2389706,271.782128 L74,404.53386 L78.5955882,404.53386 L89,269.53386 C87.3465428,270.124705 85.7521958,270.877593 84.2389706,271.782128 L84.2389706,271.782128 Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M103.567599,156.53386 C103.567599,156.53386 90.5584293,162.476226 93.408057,177.30845 L103.376989,230.53386 L109,229.586114 L103.567599,156.53386 Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B5B7",
    d: "M93.2789514,177.29359 C90.9809174,164.792292 100.282484,158.162817 103,156.53386 L103,156.53386 C103,156.53386 89.6403976,161.524908 92.3670331,176.346522 L101.905698,229.53386 L102.626114,229.410741 L93.2789514,177.29359 Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M114,223.53386 C114,223.53386 103.268139,223.468945 100.410095,229.453034 L90,250.884424 L94.0977918,251.53386 L114,223.53386 Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B5B7",
    d: "M99.600311,229.484021 C101.979782,224.423874 110.583204,223.661131 113,223.54951 L113,223.54951 C113,223.54951 102.082426,222.963501 99.2643857,228.963123 L89,250.450144 L89.5412131,250.53386 L99.600311,229.484021 Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M13.4324007,156.53386 C13.4324007,156.53386 26.4415707,162.476226 23.591943,177.30845 L13.6230112,230.53386 L8,229.586114 L13.4324007,156.53386 Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B5B7",
    d: "M23.7210486,177.29359 C26.0190826,164.792292 16.7175164,158.162817 14,156.53386 L14,156.53386 C14,156.53386 27.3596024,161.524908 24.6329669,176.346522 L15.0943019,229.53386 L14.3738865,229.410741 L23.7210486,177.29359 Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M7,222.53386 C7,222.53386 16.5648253,227.800544 15.9736861,234.489892 L14.035525,258.53386 L10.0622946,257.064087 L7,222.53386 Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B5B7",
    d: "M16.4480263,234.587685 C16.9128045,228.888477 9.99581204,223.863675 8,222.53386 L8,222.53386 C8,222.53386 17.5325087,227.558662 16.9765975,234.293226 L15.1539381,258.53386 L14.6527068,258.334387 L16.4480263,234.587685 Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M27,270.53386 C27,270.53386 49.7033786,277.675417 48.9832226,305.485927 L46.8596858,405.53386 L37.4884254,405.53386 L27,270.53386 Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E1E5",
    d: "M27,270.53386 L37.347032,405.53386 L41,405.53386 L30.7899543,272.243677 C29.5736972,271.56806 28.3061736,270.996224 27,270.53386 L27,270.53386 Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M58.7009346,262.53386 C48.8691589,262.53386 40.4579439,266.328412 37,271.6313 C43.4259006,276.157105 48.062108,282.849637 50.0841121,290.518687 C52.90373,291.200776 55.7930125,291.541497 58.6915888,291.53386 C61.138945,291.537417 63.5806857,291.295925 65.9813084,290.812765 C68.0583236,282.679783 73.0593532,275.630551 80,271.052631 C76.3271028,266.034335 68.1775701,262.53386 58.7009346,262.53386 Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7AEAF",
    d: "M63.5966407,291.127117 C60.5604945,291.127117 57.8419759,291.925657 55.1888512,291.284968 C52.6291464,281.92533 46.4821181,273.466371 41.6709942,270.105073 C43.3926764,267.710234 45.7015842,265.792482 48.3785418,264.53386 C43.2311062,266.075229 39.1579993,268.73084 37,271.962144 C43.4232836,276.392042 48.0576029,282.942752 50.0787836,290.449286 C52.8972532,291.116921 55.785359,291.450422 58.6827549,291.442819 C61.1291144,291.446428 63.5698607,291.210054 65.9695058,290.737132 C66.0816096,290.30072 65.8387179,291.154973 65.9695058,290.737132 C65.1856977,290.906942 64.3937241,291.037104 63.5966407,291.127117 L63.5966407,291.127117 Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M74.004742 400.53386C66.2760234 400.53386 60 404.684722 60 409.53386L88 409.53386C88.009484 404.684722 81.7049764 400.53386 74.004742 400.53386zM42.004742 400.53386C34.2760234 400.53386 28 404.684722 28 409.53386L56 409.53386C56.009484 404.684722 49.7049764 400.53386 42.004742 400.53386z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M74.004742 401.53386C66.2760234 401.53386 60 404.702942 60 409.53386L88 409.53386C88.009484 404.702942 81.7049764 401.53386 74.004742 401.53386zM42.004742 401.53386C34.2760234 401.53386 28 404.702942 28 409.53386L56 409.53386C56.009484 404.702942 49.7049764 401.53386 42.004742 401.53386z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M75 360.671791C71.6662144 360.671791 68.8738128 359.257998 68.1709634 357.53386L68 357.53386C68 359.257998 71.1343284 361.53386 75 361.53386 78.8656716 361.53386 82 359.257998 82 357.53386L81.8290366 357.53386C81.1546811 359.257998 78.3052917 360.671791 75 360.671791zM56.0047224 201.060991C42.1776584 201.060991 30.6362156 199.471844 27.7272431 197.53386L27 197.53386C27 199.471844 39.863703 202.53386 55.8819411 202.53386 71.9001791 202.53386 85 199.471844 85 197.53386L85 197.53386C82.1004722 199.471844 69.8317864 201.060991 56.0047224 201.060991z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFBBBC",
    d: "M56.9812237,199.286153 C43.2369699,199.286153 31.2013597,198.368722 28.309809,196.53386 L28,196.864135 C28,198.698997 40.9744254,200.53386 56.8967303,200.53386 C72.8190353,200.53386 86,198.698997 86,196.864135 L86,196.59808 C82.2635157,198.442116 70.7254775,199.286153 56.9812237,199.286153 Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D9899",
    d: "M41,360.671791 C37.6662144,360.671791 34.8738128,359.257998 34.1709634,357.53386 L34,357.53386 C34,359.257998 37.1343284,361.53386 41,361.53386 C44.8656716,361.53386 48,359.257998 48,357.53386 L47.8290366,357.53386 C47.1546811,359.257998 44.3052917,360.671791 41,360.671791 Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFBBBC",
    d: "M12.3671528,256.035022 C6.87349215,254.566931 1.91715414,256.433642 1,260.205955 L3.12149795,259.797611 C4.04791627,256.025299 7.67947609,256.491977 12.024378,257.658671 C16.3692799,258.825366 19.9267263,260.283734 19.0095721,264.056046 L20.8624088,265.53386 C21.7980913,261.761547 17.8515492,257.503112 12.3671528,256.035022 Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M12.3594393,257.189069 C6.86950652,255.75228 1.91653177,256.627675 1,260.319555 L3.12005835,260.871434 C4.04584802,257.179554 7.67494353,257.636281 12.0168971,258.7781 C16.3588507,259.919918 19.7657566,261.309131 18.8492249,265.001011 L20.8674464,265.53386 C21.7839781,261.841979 17.8401141,258.625857 12.3594393,257.189069 Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFBBBC",
    d: "M90.3671528,250.035022 C84.8734921,248.566931 79.9171541,250.433642 79,254.205955 L81.121498,253.797611 C82.0479163,250.025299 85.6794761,250.491977 90.024378,251.658671 C94.3692799,252.825366 97.9267263,254.283734 97.0095721,258.056046 L98.8624088,259.53386 C99.7980913,255.761547 95.8515492,251.503112 90.3671528,250.035022 Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CCCE",
    d: "M90.3594393,251.189069 C84.8695065,249.75228 79.9165318,250.627675 79,254.319555 L81.1200583,254.871434 C82.045848,251.179554 85.6749435,251.636281 90.0168971,252.7781 C94.3588507,253.919918 97.7657566,255.309131 96.8492249,259.001011 L98.8674464,259.53386 C99.7839781,255.841979 95.8401141,252.625857 90.3594393,251.189069 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.1959799,35.5338596 C16.1959799,35.5338596 18.2964824,37.3287041 23,37.7235699 C22.386419,39.2772828 21.9914329,40.8930567 21.8241206,42.5337532 C21.8241206,42.5337532 17.6834171,42.5875986 15,40.2722491 C15.03552,38.6367991 15.4423923,37.0247994 16.1959799,35.5338596 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.1959799,33.5338596 C16.1959799,33.5338596 18.2964824,35.3287041 23,35.7235699 C22.386419,37.2772828 21.9914329,38.8930567 21.8241206,40.5337532 C21.8241206,40.5337532 17.6834171,40.5875986 15,38.2722491 C15.03552,36.6367991 15.4423923,35.0247994 16.1959799,33.5338596 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    fillRule: "nonzero",
    d: "M44.19375,0.00944444444 C21.54375,0.358888889 3.0375,21.1083333 0,42.9627778 C12.1875,49.4983333 27.703125,50.5655556 44.775,50.3105556 C61.846875,50.0555556 77.5875,48.4877778 89.55,41.5838889 C85.865625,19.8333333 66.84375,-0.34 44.19375,0.00944444444 Z M40.59375,45.5883333 C15.65625,45.4938889 4.471875,39.1094444 3.15,36.6633333 C1.828125,34.2172222 5.68125,14.8466667 24.45,5.75166667 C36.890625,-0.283333333 72.05625,-4.14611111 79.5,28.1255556 C81.3,35.955 65.540625,45.6827778 40.59375,45.5788889 L40.59375,45.5883333 Z",
    opacity: 0.55,
    transform: "translate(12 .534)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17,32.1869846 C17,32.1869846 25.4257206,6.08698458 55,5.53385958 C55,5.53385958 29.0300567,12.5369846 23.047795,35.5338596 C23.047795,35.5057346 18.5072678,35.0838596 17,32.1869846 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "screen"
    }
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M20,31.1244478 C20,39.4726831 35.7591549,41.5338596 53.971831,41.5338596 C72.184507,41.5338596 87,35.7079772 87,27.3597419 C87,19.0115066 72.184507,9.53385958 53.971831,9.53385958 C35.7591549,9.53385958 20,22.7762125 20,31.1244478 Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC566A",
    d: "M25,30.9010024 C25,37.6795739 38.3925424,38.5338596 53.4745763,38.5338596 C68.5566102,38.5338596 81,33.9652881 81,27.1867167 C81,20.4081453 68.5566102,12.5338596 53.4745763,12.5338596 C38.3925424,12.5338596 25,24.122431 25,30.9010024 Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596B",
    d: "M26.4981665 21.0738596L26.4981665 21.0738596C26.5030558 21.047417 26.5030558 21.0203021 26.4981665 20.9938596 26.4981665 20.9938596 26.4981665 20.9938596 26.4981665 21.0538596L26.4981665 21.0538596 26.4981665 21.0738596zM26.53 22.0688596C26.5157244 22.041172 26.4951785 22.0172018 26.47 21.9988596L26.47 21.9988596 26.53 22.0688596zM30.54 25.9988596C30.5072163 26.0141059 30.4794633 26.0383898 30.46 26.0688596L30.46 26.0688596 30.54 25.9988596zM30.56 27.0396976L30.56 27.0396976C30.5215148 27.0241296 30.4784852 27.0241296 30.44 27.0396976L30.44 27.0396976 30.56 27.0396976z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E1E5",
    d: "M77.1514888 31.9856462C77.349697 32.3037918 77.6936037 32.5027396 78.0688961 32.5163604 79.8147688 32.6671905 81.4992145 31.8342142 82.435755 30.3569024 83.0818203 29.6266847 83.5969806 28.7909497 83.9586512 27.8863361 84.0661469 27.5146023 83.9604546 27.1140149 83.683429 26.8432081 83.4060945 26.5770669 83.0103383 26.4731911 82.6375846 26.5687007 80.22447 27.0720249 78.1871713 28.6739239 77.1331407 30.8967669 76.9492999 31.2382871 76.9562455 31.6504807 77.1514888 31.9856462zM23.0249381 26.3552125C23.0977744 26.814055 23.2791511 27.2452751 23.5517787 27.6077668 23.8276309 28.012123 24.1258128 28.3984587 24.4447289 28.7647062 24.7493521 29.1058036 25.0744847 29.4252015 25.4180445 29.7208544 25.998939 30.3570459 26.6495644 30.9156685 27.3557463 31.3845524 27.8545627 31.6903686 28.4902374 31.5116942 28.7844665 30.9829701 29.0718445 30.4539624 29.0718445 29.8004725 28.7844665 29.2714647 28.5801025 28.9233777 28.2219074 28.7135128 27.8379394 28.7168987 27.6378699 28.1306812 27.3677381 27.5746779 27.0342842 27.0627622 26.8011393 26.7001653 26.5413603 26.3580546 26.2574176 26.0396836L26.2038406 25.9823147C26.0394983 25.6499345 25.8320641 25.3441235 25.587705 25.0739739 25.1210404 24.5311128 24.3773839 24.3796238 23.7571572 24.701076 23.2045341 25.0247211 22.9090379 25.6922686 23.0249381 26.3552125L23.0249381 26.3552125z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#D02629",
    d: "M44.94375,49.2169811 C62.015625,48.9528302 77.578125,48.4339623 89.559375,41.5377358 C85.865625,19.8396226 66.84375,-0.339622642 44.19375,0.0283018868 C21.54375,0.396226415 3.0375,21.1037736 -9.09494702e-13,42.9339623 C12.1875,49.4433962 27.871875,49.4811321 44.94375,49.2169811 Z",
    opacity: 0.23,
    transform: "translate(12 .534)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M80.7205653,15.0263039 C82.9625514,24.4805654 71.4676228,35.2840783 55.0707247,39.1512988 C38.6738266,43.0185194 23.5214208,38.4956767 21.2794347,29.0414152 C19.0374486,19.5871537 30.5323772,8.78364083 46.9292753,4.9164203 C63.3261734,1.04919977 78.4405795,5.57204246 80.7205653,15.0263039 Z",
    opacity: 0.05,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M66.8134401,10.7097005 C68.307543,15.3343412 60.6657298,21.9151955 49.6835972,25.4097905 C38.7014647,28.9043855 28.6805066,27.9927521 27.1864037,23.3681113 C25.6923007,18.7434706 33.3436305,12.1626164 44.2686636,8.65852513 C55.1936967,5.1544339 65.3193371,6.08505975 66.8134401,10.7097005 Z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    stroke: "#979797"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgI4CIntro, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i4c-intro.4fd34e3f.svg";
export { ForwardRef as ReactComponent };